import { BaseResponse } from './../common/BaseResponse';
import { CompactUserResponse } from '@business/entities/account';

export enum HelpArticleStatus {
  public = 'public',
  private = 'private',
}

export interface ProcessSteps {
  title: string;
  content: string;
  embedUrl: string;
  image: string[];
  type: string;
}

export const HelpArticleStatuses = [HelpArticleStatus.public, HelpArticleStatus.private];

export type HelpArticleId = string;
export interface HelpArticleResponse extends BaseResponse {
  id: HelpArticleId;
  title: string;
  browserTitle: string;
  content: string;
  status: HelpArticleStatus;
  user: CompactUserResponse;
  slug: string;
  categoryId?: ArticleCategoryId;
  categorySlug: string;
  tags: string[];
  overview: string;
  bestPractices: string;
  preRequisites: string;
  definitions: string;
  conclusion: string;
  processSteps: ProcessSteps[],
  createdBy: CompactUserResponse;
  relatedArticles: HelpArticleResponse[];
}

export interface SearchHABreadcrumb {
  id: string;
  name: string;
}
export interface SearchHelpArticleResponse {
  id: HelpArticleId;
  title: string;
  content: string;
  breadcrumbs: SearchHABreadcrumb[];
}

export type CompactHelpArticleResponse = Omit<HelpArticleResponse, 'createdBy' | 'tags' | 'category' | 'categoryId' | 'slug' | 'user'>;

export type ArticleCategoryId = string;
export interface HelpArticleCategoryResponse extends BaseResponse {
  id: ArticleCategoryId;
  name: string;
  description: string;
  parent: ArticleCategoryId;
  slug: string;
  user: CompactUserResponse;
  createdBy: CompactUserResponse;
  helpArticles: HelpArticleResponse[];
  icon: string;
}

export interface HelpArticleTagResponse {
  id: string;
  name: string;
}

export type HelpArticleRequest = Pick<HelpArticleResponse, 'title' | 'content' | 'status' | 'categoryId'>;

export type HelpArticleCategoryRequest = Pick<HelpArticleCategoryResponse, 'name' | 'parent' | 'description' | 'icon'>;

/******** PUBLIC RESPONSES */

// export interface HelpArticlesPublicRequest {
//   company: string;
//   category?: string;
//   article?: string;
// }

// export interface PublicResponse {
//   company: CompanyResponse;
//   categories: HelpArticleCategoryResponse[];
// }

// export interface PublicResponseArticle extends PublicResponse {
//   helpArticle: PublicHelpArticleResponse;
// }

// export interface PublicHelpArticleResponse extends Omit<HelpArticleResponse, 'tags'> {
//   tags: HelpArticleTagResponse[];
//   frontLink: string;
//   breadcrumb: CBreadcrumbItem[];
// }

// export interface PublicHelpArticlesResponse {
//   helpArticles?: PublicHelpArticleResponse[];
//   meta: PaginateMeta;
// }

export interface HACategoryStructureResponse extends HelpArticleCategoryResponse {
  categories: HACategoryStructureResponse[];
  breadcrumbs?: HACategoryBreadcrumbResponse[];
}

export interface HACategoryBreadcrumbResponse {
  id: string;
  name: string;
}

export interface KBHelpArticleResponse extends HelpArticleResponse {
  showFeedback: boolean;
}

export interface RelatedArticles {
  id: string;
  title: string;
}